import React, { FC } from 'react';

import { List, ContainerProps } from '@lglp/components';

import { BounceDirection, DropDownArrowIcon } from '../../../Icons';
import { LinkedComponent } from '../../../LinkedComponent';
import { useDesktopContext } from './DesktopContext';
import styles from './Submenu.module.scss';

export const SubmenuItemList: FC<SubmenuItemListProps> = ({
  level,
  className,
}) => {
  const { openedMenus, openMenu, isMenuOpen } = useDesktopContext();

  return (
    <List className={[styles.submenu, className]}>
      {openedMenus[level]?.items.map((submenu, index) => (
        <List.Item
          key={index}
          onClick={() => openMenu(level + 1, submenu)}
          className={[
            submenu.isLanding && styles.landingPage,
            isMenuOpen(level + 1, submenu) && styles.selected,
            styles.item,
            'animate-svg',
          ]}
        >
          <LinkedComponent link={submenu.link} className={styles.label}>
            {submenu.label}
            {!submenu.link && (
              <DropDownArrowIcon bounceDirection={BounceDirection.RIGHT} />
            )}
          </LinkedComponent>
        </List.Item>
      ))}
    </List>
  );
};

type SubmenuItemListProps = ContainerProps & {
  level: number;
};
